export const toAssets = "/assets";
export const toIcons = "/assets/ico";
export const toIllustrations = "/assets/illustration"; 
